var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgQuestion = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "currentColor",
  viewBox: "0 0 280 280"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "m194.88 58.906 46.488 46.487v95.428c0 11.18-9.093 20.273-20.274 20.273H58.906c-11.181 0-20.274-9.092-20.274-20.273V79.179c0-11.17 9.093-20.273 20.274-20.273zm-14.333 20.273H58.906v121.642h162.198l-.01-81.095h-40.547zm10.137 81.095v20.273H79.179v-20.273zm-40.547-40.548V140H79.179v-20.274z"
})));
export default SvgQuestion;